export {GiftInCartLabel} from './GiftInCartLabel';
